export const  styles = {
  paper: {
    padding: "1em",
    textAlign: 'center',
    whiteSpace: 'nowrap',
    margin: "1em",
    background: "#fff",
    position: "relative",
    overflow: 'hidden',
    boxShadow: 'none',
    border: '1px solid #ccc'
  },
  paperIcon: {
    padding: "1em 1em 1em 5em",
    textAlign: 'center',
    whiteSpace: 'nowrap',
    margin: "1em",
    background: "#fff",
    position: "relative",
    overflow: 'hidden',
    boxShadow: 'none',
    border: '1px solid #ccc'
  },
  appBar: {
    position: 'relative',
  },
  title: {
    marginLeft: "1em",
    flex: "1",
    color: "#FFF"
  },
  fav: {
    borderRadius: "100%",
    height: "60px",
    width: "60px",
    minWidth: "60px",
    float: "right",
    marginRight: "20px"
  },
  buttonRight: {
    minWidth: "40px",
    padding: "8px"
  },
  inputBig: {
    fontSize: "30px"
  },
  iconLeft: {
    height: "40px",
    width: "40px",
    position: "absolute",
    left: "20px",
    top: "20px",
    opacity: "0.5"
  },
  iconLeftBig: {
    height: "40px",
    width: "40px",
    position: "absolute",
    left: "20px",
    top: "40px",
    opacity: "0.5"
  },
  aside: {
    width: "400px",
    marginLeft: "20px"
  },
  createContent: {
    width: "100%"
  },
  botomSpace: {
    marginBottom: "16px"
  }
};



// WEBPACK FOOTER //
// ./src/layout/Styles.js